import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 9.2905,
	height: 7.398,
	viewBox: "3.2251 4.2993 9.2905 7.398",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.95409 4.29932H8.56152V11.6973H9.95409V4.29932Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.35163 4.35372L3.2251 11.0586L4.48719 11.6471L7.61372 4.94225L6.35163 4.35372Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5156 4.29932H11.123V11.6973H12.5156V4.29932Z",
			fill: "currentColor"
		})
	]
});
export default SvgKick;
